import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { Button } from "../../components/ui/button";
import { LayoutDashboard, Package, Tag, ShoppingBag, Settings, Leaf, LogOut, ExternalLink } from "lucide-react";

const MENU = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/prodotti", label: "Prodotti", icon: Package },
  { to: "/admin/categorie", label: "Categorie", icon: Tag },
  { to: "/admin/ordini", label: "Ordini", icon: ShoppingBag },
  { to: "/admin/impostazioni", label: "Impostazioni", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  const link = ({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-emerald-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"}`;

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex flex-col w-64 bg-slate-900 text-white p-4 sticky top-0 h-screen">
        <Link to="/admin" className="flex items-center gap-2 font-display font-extrabold text-lg px-2 py-4"><Leaf className="w-6 h-6 text-emerald-400" /> Admin</Link>
        <nav className="flex-1 space-y-1 mt-4">
          {MENU.map((m) => <NavLink key={m.to} to={m.to} end={m.end} className={link} data-testid={`anav-${m.label.toLowerCase()}`}><m.icon className="w-4 h-4" /> {m.label}</NavLink>)}
        </nav>
        <div className="border-t border-slate-800 pt-3 space-y-1">
          <Link to="/" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-slate-300 hover:bg-slate-800"><ExternalLink className="w-4 h-4" /> Vai al negozio</Link>
          <button onClick={() => { logout(); navigate("/admin/login"); }} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-slate-300 hover:bg-slate-800" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Esci</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="lg:hidden bg-slate-900 overflow-x-auto flex gap-1 p-2 sticky top-0 z-30">
          {MENU.map((m) => <NavLink key={m.to} to={m.to} end={m.end} className={({ isActive }) => `px-3 py-1.5 rounded-lg text-xs whitespace-nowrap ${isActive ? "bg-emerald-600 text-white" : "text-slate-300"}`}>{m.label}</NavLink>)}
          <button onClick={() => { logout(); navigate("/admin/login"); }} className="px-3 py-1.5 rounded-lg text-xs text-slate-300">Esci</button>
        </div>
        <main className="p-5 sm:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
